import { useId } from 'react';

import { cn } from '@/shared/lib/cn';

/**
 * Salaamah mark from Group.svg — four segments pulse in sequence; optional soft glow.
 * Styles: `globals.css` (`.salaamah-mark-loader-svg`).
 */
export function SalaamahMarkLoaderSvg({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');

  return (
    <svg
      className={cn('salaamah-mark-loader-svg', className)}
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g className="salaamah-mark-loader-svg__segment">
        <path
          d="M24.4227 9.43701C24.3791 10.0243 24.0508 11.1806 24.0508 11.1806C23.3882 13.5698 19.5792 16.7525 19.5792 16.7525C20.6642 12.6214 18.1363 8.08406 14.5747 6.02548C10.9564 3.93472 6.67463 4.15658 3.19922 6.42223V6.30651C6.17479 2.13716 11.3326 -0.351223 16.4991 0.0403066C20.7931 0.365711 24.3983 4.00867 24.4584 8.32506C24.4584 8.32506 24.4584 8.9576 24.4235 9.43701H24.4227Z"
          fill="#757575"
        />
        <path
          d="M24.4227 9.43701C24.3791 10.0243 24.0508 11.1806 24.0508 11.1806C23.3882 13.5698 19.5792 16.7525 19.5792 16.7525C20.6642 12.6214 18.1363 8.08406 14.5747 6.02548C10.9564 3.93472 6.67463 4.15658 3.19922 6.42223V6.30651C6.17479 2.13716 11.3326 -0.351223 16.4991 0.0403066C20.7931 0.365711 24.3983 4.00867 24.4584 8.32506C24.4584 8.32506 24.4584 8.9576 24.4235 9.43701H24.4227Z"
          fill={`url(#smark-paint0-${uid})`}
        />
      </g>
      <g className="salaamah-mark-loader-svg__segment">
        <path
          d="M20.6764 24.1577C20.0904 24.0959 18.9435 23.7314 18.9435 23.7314C16.5749 22.9953 13.5096 19.0913 13.5096 19.0913C17.6077 20.3042 22.2265 17.9219 24.3974 14.4295C26.6023 10.8822 26.5152 6.59892 24.3574 3.05688L24.4732 3.06036C28.5512 6.16302 30.8789 11.3912 30.325 16.5385C29.8644 20.8166 26.1077 24.303 21.7876 24.2273C21.7876 24.2273 21.1545 24.2073 20.6764 24.1577Z"
          fill="#8A8A8A"
        />
        <path
          d="M20.6764 24.1577C20.0904 24.0959 18.9435 23.7314 18.9435 23.7314C16.5749 22.9953 13.5096 19.0913 13.5096 19.0913C17.6077 20.3042 22.2265 17.9219 24.3974 14.4295C26.6023 10.8822 26.5152 6.59892 24.3574 3.05688L24.4732 3.06036C28.5512 6.16302 30.8789 11.3912 30.325 16.5385C29.8644 20.8166 26.1077 24.303 21.7876 24.2273C21.7876 24.2273 21.1545 24.2073 20.6764 24.1577Z"
          fill={`url(#smark-paint1-${uid})`}
        />
      </g>
      <g className="salaamah-mark-loader-svg__segment">
        <path
          d="M6.42993 20.3981C6.48392 19.8117 6.83399 18.6615 6.83399 18.6615C7.54022 16.2853 11.4075 13.1722 11.4075 13.1722C10.2467 17.2824 12.6911 21.8659 16.2144 23.9889C19.7934 26.1458 24.0787 26.0031 27.595 23.801L27.5933 23.9167C24.542 28.0312 19.3389 30.4248 14.181 29.9375C9.89315 29.5329 6.35591 25.8247 6.37594 21.5083C6.37594 21.5083 6.38726 20.8758 6.43167 20.3973H6.42993V20.3981Z"
          fill="#757575"
        />
        <path
          d="M6.42993 20.3981C6.48392 19.8117 6.83399 18.6615 6.83399 18.6615C7.54022 16.2853 11.4075 13.1722 11.4075 13.1722C10.2467 17.2824 12.6911 21.8659 16.2144 23.9889C19.7934 26.1458 24.0787 26.0031 27.595 23.801L27.5933 23.9167C24.542 28.0312 19.3389 30.4248 14.181 29.9375C9.89315 29.5329 6.35591 25.8247 6.37594 21.5083C6.37594 21.5083 6.38726 20.8758 6.43167 20.3973H6.42993V20.3981Z"
          fill={`url(#smark-paint2-${uid})`}
        />
      </g>
      <g className="salaamah-mark-loader-svg__segment">
        <path
          d="M8.9056 6.07507C9.49514 6.08203 10.6707 6.34044 10.6707 6.34044C13.0977 6.85552 16.5095 10.4602 16.5095 10.4602C12.3166 9.63016 7.93812 12.4274 6.0981 16.1052C4.22933 19.8404 4.71263 24.0976 7.18835 27.4256L7.07254 27.4326C2.72457 24.718 -0.0750972 19.7264 0.00153439 14.5504C0.0651037 10.2479 3.48392 6.43093 7.7927 6.10814C7.7927 6.10814 8.42491 6.06985 8.9056 6.07507Z"
          fill="#757575"
        />
        <path
          d="M8.9056 6.07507C9.49514 6.08203 10.6707 6.34044 10.6707 6.34044C13.0977 6.85552 16.5095 10.4602 16.5095 10.4602C12.3166 9.63016 7.93812 12.4274 6.0981 16.1052C4.22933 19.8404 4.71263 24.0976 7.18835 27.4256L7.07254 27.4326C2.72457 24.718 -0.0750972 19.7264 0.00153439 14.5504C0.0651037 10.2479 3.48392 6.43093 7.7927 6.10814C7.7927 6.10814 8.42491 6.06985 8.9056 6.07507Z"
          fill={`url(#smark-paint3-${uid})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`smark-paint0-${uid}`}
          x1="3.19922"
          y1="8.37727"
          x2="24.4584"
          y2="8.37727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#498C8A" />
          <stop offset="0.53" stopColor="#46ACA7" />
          <stop offset="1" stopColor="#9EE2AF" />
        </linearGradient>
        <linearGradient
          id={`smark-paint1-${uid}`}
          x1="13.5096"
          y1="13.643"
          x2="30.406"
          y2="13.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#498C8A" />
          <stop offset="0.53" stopColor="#46ACA7" />
          <stop offset="1" stopColor="#9EE2AF" />
        </linearGradient>
        <linearGradient
          id={`smark-paint2-${uid}`}
          x1="6.37594"
          y1="21.5866"
          x2="27.595"
          y2="21.5866"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#498C8A" />
          <stop offset="0.53" stopColor="#46ACA7" />
          <stop offset="1" stopColor="#9EE2AF" />
        </linearGradient>
        <linearGradient
          id={`smark-paint3-${uid}`}
          x1="-0.000207233"
          y1="16.7543"
          x2="16.5095"
          y2="16.7543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#498C8A" />
          <stop offset="0.53" stopColor="#46ACA7" />
          <stop offset="1" stopColor="#9EE2AF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
